import flatpickr from "flatpickr"
import {Czech} from "flatpickr/dist/l10n/cs.js"
import "flatpickr/dist/flatpickr.css"

interface flatpickrElement extends HTMLInputElement {
  flatpickr: flatpickr
}

export {}

const dates = document.querySelectorAll(".f-date")

export const dateClear = (input: HTMLInputElement) => {
  const fp = input as flatpickrElement
  console.log(fp)
}

dates.forEach((date) => {
  const input = date.querySelector<HTMLInputElement>(".f-date__input.flatpicker")

  if (!input) return

  date.classList.remove("--native")
  input.type = "text"
  input.setAttribute("readonly", "")

  const flatpickerOptions: flatpickr.Options.Options = {
    enableTime: false,
    altInput: true,
    altFormat: "d.m.Y",
    locale: Czech,
    minDate: "today",
    mode: input.hasAttribute("data-range") ? "range" : "single",
  }

  flatpickr.l10ns.cs.rangeSeparator = " - "
  flatpickr(input, flatpickerOptions)
  })
